import SvgIcon from '@/components/SvgIcon'

// register globally
export const registerSvgIcon = app => {
  app.component('SvgIcon', SvgIcon)

  const icons = import.meta.glob('@/icons/svg/*.svg', { eager: true, query: '?raw', import: 'default' })

  const sprite = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
  sprite.setAttribute('xmlns', 'http://www.w3.org/2000/svg')
  sprite.setAttribute('style', 'display: none;')

  document.body.appendChild(sprite)

  Object.entries(icons).forEach(([path, mod]) => {
    const iconName = path.split('/').pop().replace('.svg', '')
    const parser = new DOMParser()
    const doc = parser.parseFromString(mod, 'image/svg+xml')
    const svgElement = doc.querySelector('svg')

    if (svgElement) {
      const symbolElement = document.createElementNS('http://www.w3.org/2000/svg', 'symbol')
      symbolElement.setAttribute('id', `icon-${iconName}`)
      symbolElement.setAttribute('viewBox', '0 0 1024 1024')
      symbolElement.setAttribute('xmlns', 'http://www.w3.org/2000/svg')

      while (svgElement.firstChild) {
        symbolElement.appendChild(svgElement.firstChild)
      }

      sprite.appendChild(symbolElement)
    }
  })
}
